"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTime = exports.formatDate = void 0;
var date_1 = require("../../../common/utils/date");
var formatDate = function (locale, ms) {
    return new Date(ms).toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};
exports.formatDate = formatDate;
var formatTime = function (ms) {
    var hours = '00';
    var minutes = '00';
    var seconds = '00';
    if (ms > 0) {
        hours = Math.floor(ms / date_1.MILLISECONDS.ONE_HOUR);
        minutes = Math.floor((ms % date_1.MILLISECONDS.ONE_HOUR) / date_1.MILLISECONDS.ONE_MINUTE);
        seconds = Math.floor((ms % date_1.MILLISECONDS.ONE_MINUTE) / date_1.MILLISECONDS.ONE_SECOND);
    }
    return "".concat((0, date_1.toTwoDigits)(hours), " : ").concat((0, date_1.toTwoDigits)(minutes), " : ").concat((0, date_1.toTwoDigits)(seconds)); // add localized duration
};
exports.formatTime = formatTime;
//# sourceMappingURL=format.js.map